<template>
	<div class="checkout wrapper">
		<div class="murk">
			<div class="title-header">
				<h1>
					{{ $t('code-redeem.title') }}
					<accountInfoGroup></accountInfoGroup>
					<div class="clearfix"></div>
				</h1>
			</div>

			<FormError :hide-error="hideErrorContainer" :error-code="formErrorCode"></FormError>

			<div class="code-redeem-container">
				<FormInput
					id="inputCode"
					v-model="$v.inputCode.$model"
					type="text"
					data-cy="code-input"
					:placeholder="$t('code-redeem.enter-code')"
					:has-error="submitted && $v.inputCode.$error"
					:override-error-text="$t(inputCodeErrorText)"
					:enter-handler="submitCoupon"
				>
				</FormInput>

				<FormButton
					id="submitCoupon"
					class="submit-coupon"
					data-cy="code-submit"
					type="submit"
					:button-click="submitCoupon"
					:loading="buttonLoading"
					:label="$t('submit')"
				>
				</FormButton>
			</div>
		</div>
	</div>
</template>

<script>
import { FormButton, FormInput, FormError } from '@arena/toolkit';
import accountInfoGroup from './common/account-info-group';
import { verifyCouponToken } from '../plugins/CheckoutAPI';
import store from '../store';
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'CodeRedeem',
	orderNumber: 'reviewPurchase',
	components: {
		accountInfoGroup,
		FormButton,
		FormInput,
		FormError,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('code-redeem.title')}`,
		};
	},
	data() {
		return {
			verifyTokenResponse: null,
			inputCode: '',
			buttonLoading: false,
			submitted: false,
			overrideInlineError: '',
			hideErrorContainer: true,
		};
	},
	validations: {
		inputCode: {
			required,
			isValidCode() {
				return !this.overrideInlineError;
			},
		},
	},
	computed: {
		inputCodeErrorText() {
			if (this.inputCode && this.overrideInlineError) {
				return this.overrideInlineError;
			}
			return 'error.input.inputCode';
		},
		formErrorCode() {
			return this.$store.state.form.errors.code;
		},
		language() {
			return this.$i18n.locale;
		},
	},
	watch: {
		inputCodeErrorText() {
			if (this.inputCode === '') {
				this.overrideInlineError = null;
			}
		},
	},
	created() {
		this.$store.commit('setCodeRedeemReturnUrl', this.$cookie.get('codeRedeemRetry'));
	},
	methods: {
		submitCoupon() {
			this.$v.$touch();
			this.submitted = true;
			this.overrideInlineError = null;
			if (!this.$v.$invalid) {
				this.buttonLoading = true;
				this.$checkoutAPI
					.redeemCoupon(this.inputCode, this.verifyTokenResponse.CheckoutId, this.language)
					.then((response) => {
						this.$store.commit('setCodeRedeemResult', response.data);
						this.$router.replace({ name: 'code-redeem-success' });
					})
					.catch((error) => {
						this.inputValidationError(error);
					})
					.then(() => {
						this.buttonLoading = false;
					});
			}
		},
		inputValidationError(error) {
			this.overrideInlineError = `error.form.${error.response.data.ErrorCode}`;
		},
	},
	beforeRouteEnter(to, from, next) {
		const token = to.query.token,
			locale = to.params.locale,
			// eslint-disable-next-line
			retryUrl = store.state.codeRedeemReturnUrl;

		if (!token) {
			const url = window.location.href;
			window.location.replace(url.substring(0, url.indexOf('/', 8) + 1)); // redirect to home
			return;
		}

		verifyCouponToken(token)
			.then((response) => {
				const data = response.data;

				store.commit('setUserEmail', data.Email);
				store.commit('setPaymentMethodType', data.MethodName);
				store.commit('setUserAccountType', data.AccountSourceType);
				store.commit('setCurrency', data.ItemPayment.CurrentBalance.Currency);
				store.commit('setCurrentBalance', data.ItemPayment.CurrentBalance);
				store.commit('setCheckoutId', data.CheckoutId);

				next((vm) => {
					vm.verifyTokenResponse = response.data;
				});
			})
			.catch((error) => {
				next({
					name: 'checkout-failure',
					replace: true,
					params: {
						locale,
						errorCode: error.response.data.Description,
						returnURL: retryUrl,
					},
				});
			});
	},
};
</script>

<style lang="less">
.code-redeem-container {
	max-width: 320px;
	margin: 75px auto;
	.help-block {
		position: absolute;
		width: 320px;
		line-height: 1.2em;
	}
	button {
		margin-top: 50px;
	}
}
@media (max-width: 650px) {
	.code-redeem-container {
		margin: 60px auto !important;
		.help-block {
			position: relative;
		}
		button {
			margin-top: 30px;
		}
	}
}
</style>
